import React, { useEffect, useState, useRef } from "react";
import styled, { keyframes } from "styled-components";
import { getThemeData } from "../../theme";
import { useGetTheme } from "../../lib/contexts";

const BetOptionsModal = ({ buttonTitle, modalTitle, modalContent}) => {
  const {theme} = useGetTheme();
  const [isOpen, setIsOpen] = useState(false);

  const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(5px);
    display: flex;
    align-items: center;
    justify-content: center;
  `;

  const ModalContent = styled.div`
    background: ${getThemeData(theme).ARBbgGlobal};
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
    border: 1px solid ${getThemeData(theme).ARBborderBox};
    position: relative;
    width: 300px;
    text-align: center;
  `;

  const CloseButton = styled.button`
    position: absolute;
    top: 10px;
    right: 10px;
    border: none;
    background: transparent;
    font-size: 22px;
    cursor: pointer;
    color: ${({color}) => color};
  `;

  const OpenButton = styled.button`
    padding: 10px 6px;
    width: 120px;
    background: ${({color}) => color};
    border-radius: 10px;
    border: 2px solid ${getThemeData(theme).ARBborderBox};
    cursor: pointer;
    text-align: center;
    height: fit-content;
    transition: all 0.3s ease-in-out;
    &:hover {
      filter: brightness(110%);
    }
  `;

  return (
    <div>
      <OpenButton color={getThemeData(theme).ARBbuttonColor} onClick={() => setIsOpen(true)}>
        <span style={{fontWeight: 400, fontSize: "0.9rem", color: getThemeData(theme).ARBtextColor, letterSpacing: "0.05rem"}}>
          {buttonTitle}
        </span>
      </OpenButton>
      {isOpen && (
        <ModalOverlay onClick={() => setIsOpen(false)}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <CloseButton color={getThemeData(theme).ARBtextColor} onClick={() => setIsOpen(false)}>&times;</CloseButton>
            <div style={{display: "block", height: "22px"}}/>
            <span style={{fontWeight: 600, fontSize: "1.2rem", color: getThemeData(theme).ARBtextColor, letterSpacing: "0.05rem"}}>
              {modalTitle}
            </span>
            <div style={{display: "block", height: "22px"}}/>
            {modalContent}
          </ModalContent>
        </ModalOverlay>
      )}
    </div>
  );
}

export default BetOptionsModal;